module.exports = __webpack_public_path__ + "static/img/product3.756ea62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homePage/product3.png
// module id = dE+4
// module chunks = 1